import React from 'react'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import LRTableRowLinkUI from '../../../widgets/layout/LRTableRowLinkUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import './SuSettingsPage.css'

const SuSettingsPageUI = ({ context, user, errorList, storageUsed, onDeleteStorage }) =>
  <SuperUserSettingsPageUI context={context} className='pg_settings' centered={!user}
    topnav='settings' headerText='Settings' page='settings'
  >
    {
      !user &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      user &&
      <div>
        <PageTitleUI context={context} titleText='Settings' />
        <div className='g_m_left_50'>
          {
            user.firstName &&
            <div>{user.firstName} {user.lastName}</div>
          }
          {user.email}
        </div>

        <LRTableBodyUI className='g_m_top_100'>
          <SettingsRowUI context={context} label='Logout' to='/settings/logout' />
        </LRTableBodyUI>
      </div>
    } 

    {
      user &&
      <div className='g_flex_h g_flex_top g_m_top_100'>
        <LabelAndValueUI label='Ref Id'>{context.ecid}</LabelAndValueUI>
        <span className='g_flex_h g_flex_top'>
          <LabelAndValueUI align='right' label='Browser storage used'>Approx {storageUsed}</LabelAndValueUI>
          <span className='icon icon-trash-o g_muted g_m_left_50' onClick={onDeleteStorage} />
        </span>
      </div>
    }
  </SuperUserSettingsPageUI>

const SettingsRowUI = ({ context, label, to }) =>
  <LRTableRowLinkUI
    context={context}
    to={to}
    left={<label>{label}</label>}
    right={<div className="icon icon-caret-right"></div>}
  />

export default SuSettingsPageUI
